import { CaseType } from 'app/_models/case-type/add-edit-case-type.model';
import { Country } from 'app/_models/country.model';
import { TravelInsurance } from './travel-insurance.model';
import { HealthInsurance } from './health-insurance.model';
import { ClientVm } from 'app/_mapper/client.vm';
import { NoInsurancePolicyModel } from 'app/intake/policy/models/no-insurance-policy.model';
import { CalamityModel } from 'app/calamity/models/calamity.model';
import { PersonalInfo } from './PersonalInfo.model';

export class PolicyControl {
  isowncost: boolean;
  isNoPolicycheck: boolean = null;
  country: Country;
  location: string;
  cause: CaseType;
  client = new ClientVm();
  nedherlandAla= new ClientVm();
  iagCorePartner = new ClientVm();
  iagPartnerCaseNumber: string;
  reason: string;
  personalInformations: PersonalInfo = null;
  healthInsuranceCheckResult: any;
  dossierNbr: string;
  piaCheckResult = [];
  vecozoCheckResult = [];
  selectedhealthPolicies: HealthInsurance[] = [];
  selectedtravelPolicies: TravelInsurance[] = [];
  selectedCalamities: CalamityModel = new CalamityModel();
  noInsurancePolicies: NoInsurancePolicyModel[] = [];
  travelInsuranceValidity: boolean = false;
  haveTravelInsurance: boolean = false;
  haveCalamity: boolean = false;
  isPiaCheck: boolean = false;
  isVecozoCheck: boolean = false;
  incidentDate: Date;
  showEmptyTravelInsuranceList: boolean = true;
  causes: CaseType[] = [];
}